import Highlighter from "react-highlight-words";
import { Link } from "react-router-dom";
import "./SearchPage.scss";

const SearchPageTitleBookmark = (props) => {
  var host = window.location.host;
  var protocol = window.location.protocol;
  return (
    <div className="search-title">
      <div className="search-label">
        문서명/목차 검색 :{" "}
        <span className="search-count">'{props.titleBookmark?.length}'</span> 건
      </div>
      <table>
        <thead>
          <tr>
            <th></th>
            <th>매뉴</th>
            <th>문서명</th>
            <th>목차</th>
          </tr>
        </thead>
        <tbody>
          {props.titleBookmark?.map((item, index) => {
            return (
              <tr key={index}>
                <td>{index}</td>
                <td>
                  {item.path[0]} {">"} {item.path[1]}
                </td>
                <td>
                  <Link
                    to={`${protocol}//${host}/${props.basePath}${item.url}`}
                  >
                    <span className="search-title-table-title">
                      <Highlighter
                        highlightClassName="search-highlight"
                        searchWords={[props.value] ?? ""}
                        autoEscape={true}
                        textToHighlight={item.title ?? ""}
                      />
                    </span>
                  </Link>
                </td>
                <td>
                  <ul>
                    {item?.bookmark?.map((subtitle, index) => {
                      return (
                        <Link
                          className="bookmark-link"
                          to={`${protocol}//${host}/${props.basePath}${item.url}`}
                          key={index}
                        >
                          <li
                          // onClick={() => {
                          //   navigate(`${protocol}//${host}/${manualType}${item.url}`);
                          // }}
                          >
                            <Highlighter
                              highlightClassName="search-highlight"
                              searchWords={[props.value] ?? ""}
                              autoEscape={true}
                              textToHighlight={subtitle ?? ""}
                            />
                          </li>
                        </Link>
                      );
                    })}
                  </ul>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
export default SearchPageTitleBookmark;
